/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpResponse, HttpContext, HttpParams } from '@angular/common/http';
import { DataBaseService } from '../data-base-service';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataEntriesResponseV3 } from '../models/data-entries-response-v-3';
import { DataEntry } from '../models/data-entry';
import { DataEntryKanbanViewDto } from '../models/data-entry-kanban-view-dto';
import { DataRelation } from '../models/data-relation';
import { DataRelationCountDto } from '../models/data-relation-count-dto';
import { DataRelationDto } from '../models/data-relation-dto';
import { DataRelationListDto } from '../models/data-relation-list-dto';
import { DataRelationPartialExcludingIdNormalizedName } from '../models/data-relation-partial-excluding-id-normalized-name';
import { NewDataRelation } from '../models/new-data-relation';
import { FindEntitiesRelations } from '../models/find-entities-relations';
import { Count as LoopbackCount } from '../models/loopback/count';

@Injectable({ providedIn: 'root' })
export class DataRelationControllerService extends DataBaseService {

  /**
   * Path part for operation dataRelationControllerFindEntitiesRelations
   */
  static readonly DataRelationControllerFindEntitiesRelationsPath = '/v1/entities/joiner/relations';

  /**
   * Get data entities relations
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findEntitiesRelations()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  findEntitiesRelations$Response(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
    body?: FindEntitiesRelations
  }): Observable<StrictHttpResponse<Array<DataRelationDto>>> {

    const rb = new RequestBuilder(this.rootUrl, DataRelationControllerService.DataRelationControllerFindEntitiesRelationsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<DataRelationDto>>;
      })
    );
  }
  /**
   * Get data entities relations
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findEntitiesRelations$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  findEntitiesRelations(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
    body?: FindEntitiesRelations
  }): Observable<Array<DataRelationDto>> {

    return this.findEntitiesRelations$Response(params).pipe(
      map((r: StrictHttpResponse<Array<DataRelationDto>>) => r.body as Array<DataRelationDto>)
    );
  }

  /**
   * Path part for operation dataRelationControllerFindRelatedEntriesCount
   */
  static readonly DataRelationControllerFindRelatedEntriesCountPath = '/v1/entities/{entity}/entries/{entryId}/relations/{relationId}/count';

  /**
   * Get count of related entries for specific relation that belongs to an entity
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findRelatedEntriesCount()` instead.
   *
   * This method doesn't expect any request body.
   */
  findRelatedEntriesCount$Response(params: {
    entity: string;
    entryId: string;
    relationId: string;
    where?: any;
    include_virtual?: boolean;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<LoopbackCount>> {

    const rb = new RequestBuilder(this.rootUrl, DataRelationControllerService.DataRelationControllerFindRelatedEntriesCountPath, 'get');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.path('entryId', params.entryId, {});
      rb.path('relationId', params.relationId, {});
      rb.query('where', params.where, {});
      rb.query('include_virtual', params.include_virtual, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoopbackCount>;
      })
    );
  }
  /**
   * Get count of related entries for specific relation that belongs to an entity
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findRelatedEntriesCount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findRelatedEntriesCount(params: {
    entity: string;
    entryId: string;
    relationId: string;
    where?: any;
    include_virtual?: boolean;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<LoopbackCount> {

    return this.findRelatedEntriesCount$Response(params).pipe(
      map((r: StrictHttpResponse<LoopbackCount>) => r.body as LoopbackCount)
    );
  }

  /**
   * Path part for operation dataRelationControllerFindRelatedEntriesKanbanView
   */
  static readonly DataRelationControllerFindRelatedEntriesKanbanViewPath = '/v1/entities/{entity}/entries/{entryId}/relations/{relationId}/kanban/{categoryFieldId}';

  /**
   * Get all related entries for specific relation that belongs to an entity with applied tag filter as kanban view
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findRelatedEntriesKanbanView()` instead.
   *
   * This method doesn't expect any request body.
   */
  findRelatedEntriesKanbanView$Response(params: {
    entity: string;
    entryId: string;
    relationId: string;
    categoryFieldId: string;
    filterCriteria?: any;
    search?: string;
    categoryId?: string;
    include_virtual?: boolean;
    appliedQuickFilters?: Array<string>;
    appliedTagsFilters?: Array<string>;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<DataEntryKanbanViewDto>> {

    const rb = new RequestBuilder(this.rootUrl, DataRelationControllerService.DataRelationControllerFindRelatedEntriesKanbanViewPath, 'get');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.path('entryId', params.entryId, {});
      rb.path('relationId', params.relationId, {});
      rb.path('categoryFieldId', params.categoryFieldId, {});
      rb.query('filterCriteria', params.filterCriteria, {});
      rb.query('search', params.search, {});
      rb.query('categoryId', params.categoryId, {});
      rb.query('include_virtual', params.include_virtual, {});
      rb.query('appliedQuickFilters', params.appliedQuickFilters, {});
      rb.query('appliedTagsFilters', params.appliedTagsFilters, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DataEntryKanbanViewDto>;
      })
    );
  }
  /**
   * Get all related entries for specific relation that belongs to an entity with applied tag filter as kanban view
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findRelatedEntriesKanbanView$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findRelatedEntriesKanbanView(params: {
    entity: string;
    entryId: string;
    relationId: string;
    categoryFieldId: string;
    filterCriteria?: any;
    search?: string;
    categoryId?: string;
    include_virtual?: boolean;
    appliedQuickFilters?: Array<string>;
    appliedTagsFilters?: Array<string>;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<DataEntryKanbanViewDto> {

    return this.findRelatedEntriesKanbanView$Response(params).pipe(
      map((r: StrictHttpResponse<DataEntryKanbanViewDto>) => r.body as DataEntryKanbanViewDto)
    );
  }

  /**
   * Path part for operation dataRelationControllerFindRelatedEntries
   */
  static readonly DataRelationControllerFindRelatedEntriesPath = '/v1/entities/{entity}/entries/{entryId}/relations/{relationId}';

  /**
   * Get all related entries for specific relation that belongs to an entity
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findRelatedEntries()` instead.
   *
   * This method doesn't expect any request body.
   */
  findRelatedEntries$Response(params: {
    entity: string;
    entryId: string;
    relationId: string;
    filter?: any;
    include_virtual?: boolean;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Array<DataEntry>>> {

    const rb = new RequestBuilder(this.rootUrl, DataRelationControllerService.DataRelationControllerFindRelatedEntriesPath, 'get');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.path('entryId', params.entryId, {});
      rb.path('relationId', params.relationId, {});
      rb.query('filter', params.filter, {});
      rb.query('include_virtual', params.include_virtual, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<DataEntry>>;
      })
    );
  }
  /**
   * Get all related entries for specific relation that belongs to an entity
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findRelatedEntries$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findRelatedEntries(params: {
    entity: string;
    entryId: string;
    relationId: string;
    filter?: any;
    include_virtual?: boolean;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Array<DataEntry>> {

    return this.findRelatedEntries$Response(params).pipe(
      map((r: StrictHttpResponse<Array<DataEntry>>) => r.body as Array<DataEntry>)
    );
  }

  /**
   * Path part for operation dataRelationControllerCount
   */
  static readonly DataRelationControllerCountPath = '/v1/entities/{entity}/relation/count';

  /**
   * Count relations for specific entity
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `count()` instead.
   *
   * This method doesn't expect any request body.
   */
  count$Response(params: {
    entity: string;
    where?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<LoopbackCount>> {

    const rb = new RequestBuilder(this.rootUrl, DataRelationControllerService.DataRelationControllerCountPath, 'get');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.query('where', params.where, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoopbackCount>;
      })
    );
  }
  /**
   * Count relations for specific entity
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `count$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  count(params: {
    entity: string;
    where?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<LoopbackCount> {

    return this.count$Response(params).pipe(
      map((r: StrictHttpResponse<LoopbackCount>) => r.body as LoopbackCount)
    );
  }

  /**
   * Path part for operation dataRelationControllerFindById
   */
  static readonly DataRelationControllerFindByIdPath = '/v1/entities/{entity}/relation/{id}';

  /**
   * Get specific relation for specific entity
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findById()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById$Response(params: {
    entity: string;
    id: string;
    filter?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<DataRelationDto>> {

    const rb = new RequestBuilder(this.rootUrl, DataRelationControllerService.DataRelationControllerFindByIdPath, 'get');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.path('id', params.id, {});
      rb.query('filter', params.filter, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DataRelationDto>;
      })
    );
  }
  /**
   * Get specific relation for specific entity
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById(params: {
    entity: string;
    id: string;
    filter?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<DataRelationDto> {

    return this.findById$Response(params).pipe(
      map((r: StrictHttpResponse<DataRelationDto>) => r.body as DataRelationDto)
    );
  }

  /**
   * Path part for operation dataRelationControllerDeleteById
   */
  static readonly DataRelationControllerDeleteByIdPath = '/v1/entities/{entity}/relation/{id}';

  /**
   * Delete specific relation that belongs to an entity
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteById()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById$Response(params: {
    entity: string;
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, DataRelationControllerService.DataRelationControllerDeleteByIdPath, 'delete');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.path('id', params.id, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }
  /**
   * Delete specific relation that belongs to an entity
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById(params: {
    entity: string;
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<any> {

    return this.deleteById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation dataRelationControllerUpdateById
   */
  static readonly DataRelationControllerUpdateByIdPath = '/v1/entities/{entity}/relation/{id}';

  /**
   * Update specific relation that belongs to an entity
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById$Response(params: {
    entity: string;
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: DataRelationPartialExcludingIdNormalizedName
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, DataRelationControllerService.DataRelationControllerUpdateByIdPath, 'patch');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }
  /**
   * Update specific relation that belongs to an entity
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById(params: {
    entity: string;
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: DataRelationPartialExcludingIdNormalizedName
  }): Observable<any> {

    return this.updateById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation dataRelationControllerFind
   */
  static readonly DataRelationControllerFindPath = '/v1/entities/{entity}/relation';

  /**
   * Get all relations for specific entity
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `find()` instead.
   *
   * This method doesn't expect any request body.
   */
  find$Response(params: {
    entity: string;
    filter?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Array<DataRelationDto>>> {

    const rb = new RequestBuilder(this.rootUrl, DataRelationControllerService.DataRelationControllerFindPath, 'get');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.query('filter', params.filter, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<DataRelationDto>>;
      })
    );
  }
  /**
   * Get all relations for specific entity
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `find$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  find(params: {
    entity: string;
    filter?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Array<DataRelationDto>> {

    return this.find$Response(params).pipe(
      map((r: StrictHttpResponse<Array<DataRelationDto>>) => r.body as Array<DataRelationDto>)
    );
  }

  /**
   * Path part for operation dataRelationControllerCreate
   */
  static readonly DataRelationControllerCreatePath = '/v1/entities/{entity}/relation';

  /**
   * Create new relation for specific entity
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `create()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create$Response(params: {
    entity: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: NewDataRelation
  }): Observable<StrictHttpResponse<DataRelation>> {

    const rb = new RequestBuilder(this.rootUrl, DataRelationControllerService.DataRelationControllerCreatePath, 'post');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.body(params.body, 'application/json');
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DataRelation>;
      })
    );
  }
  /**
   * Create new relation for specific entity
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `create$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create(params: {
    entity: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: NewDataRelation
  }): Observable<DataRelation> {

    return this.create$Response(params).pipe(
      map((r: StrictHttpResponse<DataRelation>) => r.body as DataRelation)
    );
  }

  /**
   * Path part for operation dataRelationControllerFindRelatedEntriesCountV2
   */
  static readonly DataRelationControllerFindRelatedEntriesCountV2Path = '/v2/entities/{entity}/entries/{entryId}/relations/{relationId}/count';

  /**
   * Get count of related entries for specific relation that belongs to an entity
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findRelatedEntriesCountV2()` instead.
   *
   * This method doesn't expect any request body.
   */
  findRelatedEntriesCountV2$Response(params: {
    entity: string;
    entryId: string;
    relationId: string;
    whereCriteria?: any;
    search?: string;
    include_virtual?: boolean;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<LoopbackCount>> {

    const rb = new RequestBuilder(this.rootUrl, DataRelationControllerService.DataRelationControllerFindRelatedEntriesCountV2Path, 'get');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.path('entryId', params.entryId, {});
      rb.path('relationId', params.relationId, {});
      rb.query('whereCriteria', params.whereCriteria, {});
      rb.query('search', params.search, {});
      rb.query('include_virtual', params.include_virtual, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoopbackCount>;
      })
    );
  }
  /**
   * Get count of related entries for specific relation that belongs to an entity
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findRelatedEntriesCountV2$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findRelatedEntriesCountV2(params: {
    entity: string;
    entryId: string;
    relationId: string;
    whereCriteria?: any;
    search?: string;
    include_virtual?: boolean;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<LoopbackCount> {

    return this.findRelatedEntriesCountV2$Response(params).pipe(
      map((r: StrictHttpResponse<LoopbackCount>) => r.body as LoopbackCount)
    );
  }

  /**
   * Path part for operation dataRelationControllerFindRelatedEntriesV2
   */
  static readonly DataRelationControllerFindRelatedEntriesV2Path = '/v2/entities/{entity}/entries/{entryId}/relations/{relationId}';

  /**
   * Get all related entries for specific relation that belongs to an entity
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findRelatedEntriesV2()` instead.
   *
   * This method doesn't expect any request body.
   */
  findRelatedEntriesV2$Response(params: {
    entity: string;
    entryId: string;
    relationId: string;
    filterCriteria?: any;
    search?: string;
    include_virtual?: boolean;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Array<DataEntry>>> {

    const rb = new RequestBuilder(this.rootUrl, DataRelationControllerService.DataRelationControllerFindRelatedEntriesV2Path, 'get');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.path('entryId', params.entryId, {});
      rb.path('relationId', params.relationId, {});
      rb.query('filterCriteria', params.filterCriteria, {});
      rb.query('search', params.search, {});
      rb.query('include_virtual', params.include_virtual, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<DataEntry>>;
      })
    );
  }
  /**
   * Get all related entries for specific relation that belongs to an entity
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findRelatedEntriesV2$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findRelatedEntriesV2(params: {
    entity: string;
    entryId: string;
    relationId: string;
    filterCriteria?: any;
    search?: string;
    include_virtual?: boolean;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Array<DataEntry>> {

    return this.findRelatedEntriesV2$Response(params).pipe(
      map((r: StrictHttpResponse<Array<DataEntry>>) => r.body as Array<DataEntry>)
    );
  }

  /**
   * Path part for operation dataRelationControllerCountV2
   */
  static readonly DataRelationControllerCountV2Path = '/v2/entities/{entity}/relation/count';

  /**
   * Count relations for specific entity
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `countV2()` instead.
   *
   * This method doesn't expect any request body.
   */
  countV2$Response(params: {
    entity: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<DataRelationCountDto>> {

    const rb = new RequestBuilder(this.rootUrl, DataRelationControllerService.DataRelationControllerCountV2Path, 'get');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DataRelationCountDto>;
      })
    );
  }
  /**
   * Count relations for specific entity
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `countV2$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  countV2(params: {
    entity: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<DataRelationCountDto> {

    return this.countV2$Response(params).pipe(
      map((r: StrictHttpResponse<DataRelationCountDto>) => r.body as DataRelationCountDto)
    );
  }

  /**
   * Path part for operation dataRelationControllerFindV2
   */
  static readonly DataRelationControllerFindV2Path = '/v2/entities/{entity}/relation';

  /**
   * Get all relations for specific entity
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findV2()` instead.
   *
   * This method doesn't expect any request body.
   */
  findV2$Response(params: {
    entity: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<DataRelationListDto>> {

    const rb = new RequestBuilder(this.rootUrl, DataRelationControllerService.DataRelationControllerFindV2Path, 'get');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DataRelationListDto>;
      })
    );
  }
  /**
   * Get all relations for specific entity
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findV2$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findV2(params: {
    entity: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<DataRelationListDto> {

    return this.findV2$Response(params).pipe(
      map((r: StrictHttpResponse<DataRelationListDto>) => r.body as DataRelationListDto)
    );
  }

  /**
   * Path part for operation dataRelationControllerFindRelatedEntriesV3
   */
  static readonly DataRelationControllerFindRelatedEntriesV3Path = '/v3/entities/{entity}/entries/{entryId}/relations/{relationId}';

  /**
   * Get all related entries for specific relation that belongs to an entity with applied tag filter
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findRelatedEntriesV3()` instead.
   *
   * This method doesn't expect any request body.
   */
  findRelatedEntriesV3$Response(params: {
    entity: string;
    entryId: string;
    relationId: string;
    filterCriteria?: any;
    search?: string;
    include_virtual?: boolean;
    appliedQuickFilters?: Array<string>;
    appliedTagsFilters?: Array<string>;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<DataEntriesResponseV3>> {

    const rb = new RequestBuilder(this.rootUrl, DataRelationControllerService.DataRelationControllerFindRelatedEntriesV3Path, 'get');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.path('entryId', params.entryId, {});
      rb.path('relationId', params.relationId, {});
      rb.query('filterCriteria', params.filterCriteria, {});
      rb.query('search', params.search, {});
      rb.query('include_virtual', params.include_virtual, {});
      rb.query('appliedQuickFilters', params.appliedQuickFilters, {});
      rb.query('appliedTagsFilters', params.appliedTagsFilters, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DataEntriesResponseV3>;
      })
    );
  }
  /**
   * Get all related entries for specific relation that belongs to an entity with applied tag filter
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findRelatedEntriesV3$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findRelatedEntriesV3(params: {
    entity: string;
    entryId: string;
    relationId: string;
    filterCriteria?: any;
    search?: string;
    include_virtual?: boolean;
    appliedQuickFilters?: Array<string>;
    appliedTagsFilters?: Array<string>;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<DataEntriesResponseV3> {

    return this.findRelatedEntriesV3$Response(params).pipe(
      map((r: StrictHttpResponse<DataEntriesResponseV3>) => r.body as DataEntriesResponseV3)
    );
  }

}
